<template>
    <div class="privacy-policy" ref="policy">
        <div class="privacy-main" v-html="privacyPolicy.materialContent"></div>
        <div v-if="privacyPolicy.showWaterMark">
            <div class="printMain" ref="printMain" v-for="index of printLen" :key="index"
                 :style="{ top: index * 200 + 'px' }">
                <p>{{ privacyPolicy.nickName }}</p>
                <p>{{ privacyPolicy.mobile }}</p>
            </div>
        </div>
    </div>
</template>
<script>
    import {setTitle} from "@/utils/bridge";
    import sensors from "sa-sdk-javascript";

    export default {
        data() {
            return {
                privacyPolicy: {},
                pageTitle: "",
                printLen: 0,
                token: "",
                timer: null
            };
        },
        mounted: function () {


            const urlParams = this.$route.query;
            const {type} = urlParams;
            if (type === "0") {
                //相关文件
                sensors.track("TMRelatedDoc");
            } else {
                //理财指南
                sensors.track("TMFinancialGuide");
            }
        },
        created() {
            const urlParams = this.$route.query;
            const {token, materialId} = urlParams;
            this.token = decodeURIComponent(token || "");
            //修改标题  理财指南
            this.getData(this.token, materialId); //详细内容
        },
        methods: {
            getData: function (code, materialId) {
                this.$request({
                    method: "post",
                    url: `/h5/sesame/materialInfo/${materialId}.json`,
                    data: this.$qs.stringify({
                        token: code
                    })
                })
                    .then(res => {
                        const {code, msg, data} = res;
                        this.privacyPolicy = data;
                        setTitle(data.materialName);
                        this.timer = setTimeout(() => {
                            let policyH = this.$refs.policy.offsetHeight;
                            this.printLen = parseInt(policyH / 100) > 1 ? parseInt(policyH / 100) : 1;
                            clearTimeout(this.timer);
                        }, 200);
                    })
                    .catch(err => {
                        this.$toast(err);
                    });
            }
        }
    };
</script>

<style lang="less">
    .privacy-policy {
        width: 100%;
        background: #fff;
        border-radius: 20px;
        padding: 20px 16px;
        margin-bottom: 10px;
        position: relative;
        box-sizing: border-box !important;
        overflow: hidden;

        .privacy-main {
            font-size: 13px;
            color: #888888;
            line-height: 20px;
            z-index: 100;

            p {
                img {
                    display: block;
                    width: 100% !important;
                }
            }
        }

        img {
            display: block;
            width: 100% !important;
        }

        .privacy-title {
            text-align: center;
            display: block;
            width: 100%;
            font-size: 15px;
            color: #333333;
            margin-bottom: 18px;
            line-height: 20px;
        }

        p {
            display: block;
            font-size: 12px;
            color: #888888;
            text-align: justify;
            line-height: 22px;
            font-weight: 300;
        }
    }

    .printMain {
        z-index: 10 !important;
        width: 93%;
        /*height: 300px;*/
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transform: rotate(340deg);
        /*margin-bottom: 90px;*/
        box-sizing: border-box;
        position: absolute;
        left: 0;

        p {
            font-size: 28px;
            line-height: 32px;
            color: #c0a266;
        }
    }
</style>
